module.exports = __webpack_public_path__ + "static/img/reward-2.2f53caf8.png";